import { useState } from 'react';
import { filterChips, hotRoutes } from '@/mocks/routeData';

export default function FirstScreen() {
  const [active, setActive] = useState('全部');
  return (
    <section id="hot" className="relative overflow-hidden">
      {/* 背景暖光 */}
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-0 h-72 bg-gradient-to-b from-orange-100/60 to-transparent" />

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        {/* 杂志刊头 */}
        <div className="flex flex-col gap-6 pt-9 md:pt-12">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-orange-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">今日观剧指南 · GUIDE</span>
          </div>
          <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <h1 className="font-mag max-w-3xl text-3xl font-black leading-tight text-stone-900 md:text-5xl">
              把每一部剧，都按<em className="not-italic text-orange-600">对顺序</em>看下去
            </h1>
            <p className="max-w-md text-sm leading-7 text-stone-500 md:text-base">
              吃瓜线路持续整理热门剧集的<strong className="font-semibold text-stone-700">观看顺序</strong>与
              <strong className="font-semibold text-stone-700">推荐路线</strong>，流畅线路保证不卡顿、高清线路保留最佳画质，点开即可顺着看。
            </p>
          </div>

          {/* 筛选条 */}
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="no-scrollbar flex items-center gap-2 overflow-x-auto">
              {filterChips.map((c) => (
                <button
                  key={c}
                  onClick={() => setActive(c)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition ${
                    active === c
                      ? 'bg-stone-900 text-white'
                      : 'bg-white text-stone-600 ring-1 ring-stone-200 hover:bg-stone-100'
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <span className="shrink-0 text-xs text-stone-400">
              已整理 <b className="text-stone-700">5</b> 份今日新单 · <b className="text-stone-700">62</b> 部在线
            </span>
          </div>
        </div>

        {/* 多卡并列首屏 */}
        <div className="grid grid-cols-1 gap-4 pt-7 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {hotRoutes.map((r, i) => (
            <a
              key={r.title}
              href="#order"
              className="group relative flex cursor-pointer flex-col rounded-xl border border-stone-200/80 bg-white p-5 transition hover:-translate-y-0.5 hover:border-orange-300"
            >
              <span className="absolute left-0 top-5 h-8 w-1 rounded-r-full bg-orange-400" />
              <div className="flex items-center justify-between">
                <span className={`rounded-md px-2 py-0.5 text-[11px] font-semibold ${r.tagClass}`}>{r.tag}</span>
                <span className="text-[11px] text-stone-400">{r.meta}</span>
              </div>
              <div className="mt-4 flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-50 text-xl text-orange-600">
                  <i className={r.icon} />
                </span>
                <div className="min-w-0">
                  <p className="text-[11px] font-medium tracking-wide text-teal-600">{r.line}</p>
                  <h3 className="mt-0.5 text-base font-bold leading-snug text-stone-900 group-hover:text-orange-700 md:text-[17px]">
                    {r.title}
                  </h3>
                </div>
              </div>
              <p className="mt-3 flex-1 text-[13px] leading-6 text-stone-500">{r.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-dashed border-stone-200 pt-3 text-xs text-stone-400">
                <span>{r.steps}</span>
                <span className="flex items-center gap-1 font-medium text-orange-600">
                  顺着看 <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                </span>
              </div>
            </a>
          ))}

          {/* 收口 CTA 卡片 */}
          <a
            href="#order"
            className="group relative flex cursor-pointer flex-col justify-center overflow-hidden rounded-xl bg-stone-900 p-5 text-white"
          >
            <span className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-orange-500/20" />
            <span className="absolute -bottom-8 -right-2 h-24 w-24 rounded-full bg-orange-500/10" />
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-500/20 text-orange-300">
              <i className="ri-road-map-line text-xl" />
            </span>
            <h3 className="font-mag mt-4 text-xl font-bold leading-snug">
              想要一整套「最佳路径」？
            </h3>
            <p className="mt-2 text-sm leading-6 text-stone-300">
              去观看顺序合集，按无剧透 / 完整世界观 / 补彩蛋三档挑着看。
            </p>
            <span className="mt-5 flex items-center gap-1 text-sm font-medium text-orange-300">
              打开顺序合集 <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}